import { useEffect } from 'react';
import { ProjectComponent } from 'components/Project';
import { exampleProject, exampleProjectItems } from 'utils/exampleproject.util';
import { useTutorialContext } from 'tutorials/tutorial.context';

export const ExampleProjectPage = () => {
  const { state, setState } = useTutorialContext();
  useEffect(() => {
    if (window.centerpieceapiconfig)
      window.centerpieceapiconfig.blockAPI = true;
    if (state.tourActive) {
      setState(currState => ({
        ...currState,
        run: true,
      }));
    }

    return function cleanup() {
      if (window.centerpieceapiconfig)
        window.centerpieceapiconfig.blockAPI = false;
      setState(currState => ({ ...currState, run: false }));
    };
    // eslint-disable-next-line
  }, []);
  return (
    <ProjectComponent
      id={0}
      template={false}
      exampleProject={{ project: exampleProject, items: exampleProjectItems }}
    />
  );
};
